import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function PDFAnnotatorMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "PDF Annotator Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_annotator", title: "Annotate PDF Files For Free" },
    data2: {
      link: "/pdf_annotator",
      title: "Edit, Comment, Annotate PDF Free",
    },
    data3: { link: "/pdf_annotator", title: "Highlight PDF, PDF Annotator" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Annotate PDF online easily. Add comments, highlights, drawings, and notes to PDFs quickly with our fast and secure PDF annotator tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf annotator, annotate pdf, pdf annotation tool, add comments to pdf, highlight pdf, draw on pdf, pdf editor online, online pdf annotator, add notes to pdf, pdf markup tool, pdf highlighter, annotate pdf online, pdf annotation software, pdf commenting tool, pdf review tool"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <></>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1615002918}`}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF annotator offline website is a powerful and secure tool designed to let users add comments, highlights, notes, and drawings to PDF documents directly on their device, without the need for an internet connection. This advanced offline PDF annotation tool allows students, professionals, and businesses to review, edit, and collaborate on PDFs efficiently while keeping sensitive documents private. With features such as text highlighting, underlining, striking through, sticky notes, freehand drawing, and shape annotations, this PDF annotator offline ensures that your feedback and edits are precise, organized, and professional. Whether you are annotating academic assignments, business reports, contracts, or research papers, our offline PDF annotation software preserves all changes securely and works seamlessly without uploading files to the cloud. The platform is compatible with Windows, macOS, and other devices, allowing users to annotate PDFs anytime, anywhere. By providing fast, reliable, and offline PDF editing capabilities, this offline PDF annotator enhances productivity, simplifies document collaboration, and ensures your data remains fully private. If you’re looking for a safe, high performance, and feature rich PDF annotator offline tool, this website is the perfect solution for all your PDF reviewing and annotation needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Upload",
              step3: "Annotate",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Annotator"
            why_use={[
              {
                title: "Add Comments and Notes Easily",
                description:
                  "This PDF annotator tool allows users to insert comments, notes, and explanations directly into PDF documents, making it easier to review and provide feedback.",
              },

              {
                title: "Highlight Important Text",
                description:
                  "With a PDF annotation tool online or offline, you can highlight key points in reports, contracts, or research papers for quick reference and clarity.",
              },

              {
                title: "Underline and Strike Through Text",
                description:
                  "Our PDF annotator lets you underline or strike through text, helping to mark important information or indicate corrections efficiently.",
              },

              {
                title: "Draw and Mark Shapes",
                description:
                  "Advanced PDF annotation tools allow freehand drawing, shapes, and arrows, enabling visual annotations that make documents more interactive and clear.",
              },

              {
                title: "Improve Collaboration and Feedback",
                description:
                  "Using a PDF annotator online or offline helps teams, students, and professionals review documents collaboratively, leaving precise feedback directly in the PDF.",
              },

              {
                title: "Preserve Original Document Layout",
                description:
                  "This reliable PDF annotation tool maintains the original formatting, fonts, and layout of your PDF while allowing edits and annotations.",
              },

              {
                title: "Works Offline for Data Privacy",
                description:
                  "Our offline PDF annotator allows you to annotate documents without uploading them online, keeping sensitive data secure and private.",
              },

              {
                title: "Enhance Productivity and Efficiency",
                description:
                  "Our PDF annotator tool saves time by enabling quick edits, comments, and highlights without converting files to other formats.",
              },

              {
                title: "Ideal for Academic and Business Use",
                description:
                  "Whether marking lecture notes, reviewing research papers, editing contracts, or auditing reports, a PDF annotator is essential for students, teachers, and professionals.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default PDFAnnotatorMain;
